export const THEME_PRESETS = {
  classic: { label: "Rot / Orange", primary: "#E11D48", secondary: "#F59E0B" },
  warm: { label: "Warm", primary: "#EA580C", secondary: "#F59E0B" },
  cool: { label: "Kühl", primary: "#0EA5E9", secondary: "#6366F1" },
  forest: { label: "Grün", primary: "#16A34A", secondary: "#65A30D" },
  ink: { label: "Elegant", primary: "#111827", secondary: "#6B7280" },
};

export const LOYALTY_MODE_LABELS = {
  stamp_fixed: "Stempel pro Einkauf",
  stamp_spend: "Stempel nach Umsatz",
  points_spend: "Punkte nach Umsatz",
};

export function brandVars(primary, secondary) {
  return {
    "--brand-primary": primary || "#0F766E",
    "--brand-secondary": secondary || "#14B8A6",
  };
}

export const BrandScope = ({ primary, secondary, children, className = "", style = {}, ...rest }) => (
  <div className={className} style={{ ...brandVars(primary, secondary), ...style }} {...rest}>
    {children}
  </div>
);
